import { useEffect, useRef } from 'react';
import { useAppSelector } from '../app/hooks';
import keycloak from '../lib/keycloak';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const loginTriggered = useRef(false);

  useEffect(() => {
    if (!isAuthenticated && !keycloak.authenticated && !loginTriggered.current) {
      loginTriggered.current = true;
      keycloak.login({ redirectUri: window.location.href });
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
